<template>
	<div>
		<CRow>
			<CCol>
				<div class="form-group">
					<label>Rechercher des colis</label>
					<GTreeView
						input-name="packages"
						placeholder="Entrez la référence d'un colis"
						v-on:update:selected="updatePackages"
						:multiple="true"
						:async="true"
						:load-options="loadOptions" />
				</div>
			</CCol>
		</CRow>
	</div>
</template>

<script>
	import GTreeView from '../../../../components/ghostlexly-components/GTreeView';
	export default {
		components: {
			GTreeView,
		},
		data() {
			return {
				packages: [],
			};
		},
		methods: {
			updatePackages(values) {
				this.packages = values;
			},
			loadOptions({ action, searchQuery, callback }) {
				if (action === 'ASYNC_SEARCH') {
					this.$axios.get(`/api/order_items?blocked=0&id=${searchQuery}`).then(res => {
						const options = res.data['hydra:member'].map(item => {
							return {
								'@id': item.id,
								name: `${item.name} - ${item.id}`,
							};
						});
						callback(null, options);
					});
				}
			},
		},
		mounted() {},
	};
</script>
